import create from 'utils/createReduxPromiseActionType'

export const CLEAR_AGENDA_ITEMS = 'agenda/CLEAR_AGENDA_ITEMS'
export const LOAD_AGENDA_ITEMS = create('agenda/LOAD_AGENDA_ITEMS')
export const REMOVE_AGENDA_ITEM = create('agenda/REMOVE_AGENDA_ITEM')
export const ADD_AGENDA_ITEM = create('agenda/ADD_AGENDA_ITEM')
export const ADD_AGENDA_ITEM_GUESTS = create('agenda/ADD_AGENDA_ITEM_GUESTS')
export const EDIT_AGENDA_ITEM = create('agenda/EDIT_AGENDA_ITEM')
export const LOAD_AGENDA_ITEM = create('agenda/LOAD_AGENDA_ITEM')
